"use client"
import Link from "next/link";
import useMount from "react-use/lib/useMount";
import styles from './portfolios.module.css';
import wrappers from "components/_styled/wrappers.module.css"

import logEvent from "lib/ga/miscEvent";
import logInternalLinkClick from "lib/ga/internalLinkClick";
import logPageView from "lib/ga/pageView";
import type { PortfolioType } from "lib/types";

const PortfoliosPage = ({ portfolios }: { portfolios: PortfolioType[] }) => {
  useMount(() => {
    logPageView({ url: window.location.pathname + window.location.search });
  });
  return (
    <div className={wrappers.FluidWrapper}>
      <div className={`${styles.Intro} ${wrappers.Row}`}>
        <h1>Harness the power of portfolios</h1>
        <p>
          Unique to {process.env.NEXT_PUBLIC_APP_NAME}, you can access comprehensive information on the UK's leading
          retail portfolios here, scheme by scheme.
        </p>
      </div>

      <div className={` ${wrappers.Row} ${styles.Grid}`}>
        {Object.keys(portfolios).map((value, index: number) => {
          const portfolio = portfolios[index];
        return (
            <div className={styles.Card} key={portfolio.id}>
              <Link href={`/portfolio/${portfolio.uri}`} passHref prefetch={false} legacyBehavior>
                <a
                  onClick={() => {
                    logInternalLinkClick("Portfolio Tile", `/portfolio/${portfolio.uri}`);
                    logEvent({
                      category: "Portfolios Page",
                      action: "Click",
                      label: `Portfolio: ${portfolio.name}`,
                    });
                  }}
                  style={{ backgroundColor: portfolio.dark }}
                >
                  <img
                    src={`/images/portfolios/${portfolio.uri.toLowerCase()}/logo.svg`}
                    alt={`View ${portfolio.name}'s portfolio on Completely Retail`}
                    width="200"
                    height="200"
                    loading={index > 1 ? "lazy" : undefined}
                  />
                </a>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PortfoliosPage;
